<template>
    <el-dialog
        :visible.sync="visibleSync"
        width="480px"
        append-to-body
        class="confirm-dialog"
        :class="`${showTab}_dialog`"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        center
        v-bind="dialogOptions"
    >
        <template #title>
            <slot name="title">
                <div class="header-title" :class="`${showTab}_title`">
                    <div class="id-role">
                        {{ title }}
                    </div>
                    <img
                        :src="popupRight"
                        class="pop-right"
                        alt=""
                        width="150"
                    />
                </div>
            </slot>
        </template>

        <div class="content">
            {{ msg }}
        </div>

        <DialogFooter
            :showTab="showTab"
            @confirm="handleConfirm"
            @cancel="handleCancel"
            :loading="loading"
            :confirmText="mergedFooterProps.confirmText"
            :cancelText="mergedFooterProps.cancelText"
            :top="mergedFooterProps.top"
            :reverse="mergedFooterProps.reverse"
            :confirmOptions="mergedFooterProps.confirmOptions"
            :cancelOptions="mergedFooterProps.cancelOptions"
            v-bind="mergedFooterProps.attrs"
        />
    </el-dialog>
</template>

<script>
import DialogFooter from "../layout/DialogFooter.vue";

export default {
    name: "confirm-dialog",
    components: {
        DialogFooter,
    },
    data() {
        return {
            visibleSync: false,
            msg: "",
            title: "提示",
            showTab: "NB",
            loading: false,
            popupRight: require("@/assets/img/login/pupup_right.png"),

            // 兼容 AlertTipsDialog 的字段命名
            btnText: "取消",
            confirmText: "确定",
            needCancel: true,
            callBack: null,
            callCancelBack: null,

            // 可通过注册/调用注入
            dialogOptions: {},
            footerProps: {},
        };
    },
    computed: {
        mergedFooterProps() {
            const p = this.footerProps || {};
            const attrs = p.attrs || {};
            const needCancel = this.needCancel !== false;
            const cancelText = needCancel ? p.cancelText || this.btnText : "";
            const confirmText = needCancel
                ? p.confirmText || this.confirmText
                : "";
            return {
                confirmText,
                cancelText,
                top: p.top || "20",
                reverse: p.reverse !== undefined ? p.reverse : false,
                confirmOptions: p.confirmOptions || {},
                cancelOptions: p.cancelOptions || {},
                attrs,
            };
        },
    },
    methods: {
        open(options = {}) {
            const {
                msg = "",
                title = "提示",
                showType = "NB",
                loading = false,
                // 与 AlertTipsDialog 对齐（btnText = 取消按钮文案）
                btnText = "取消",
                confirmText = "确定",
                needCancel = true,
                callBack = null,
                callCancelBack = null,
                dialogOptions = {},
                footerProps = {},
            } = options;

            this.msg = msg;
            this.title = title || "提示";
            this.showTab = showType || "NB";
            this.loading = !!loading;

            this.btnText = btnText;
            this.confirmText = confirmText;
            this.needCancel = needCancel;
            this.callBack = callBack;
            this.callCancelBack = callCancelBack;

            this.dialogOptions = dialogOptions || {};
            this.footerProps = footerProps || {};

            this.visibleSync = true;
        },
        handleCancel() {
            this.visibleSync = false;
            this.callBack && this.callBack();
        },
        handleConfirm() {
            this.visibleSync = false;
            this.callCancelBack && this.callCancelBack();
        },
        cancel() {
            this.visibleSync = false;
        },
    },
};
</script>

<style scoped lang="stylus">
.confirm-dialog{
    .header-title{
        background: linear-gradient(to right, #de5d40, #e5917e, #daacb9);
        height:50px;
        border-radius:10px 10px 0 0;
        position:relative;
        .id-role{
            position:absolute;
            left:0;
            right:0;
            margin: 0 auto;
            width: fit-content;
            color:white;
            top:10px;
            font-size:24px;
        }
        .pop-right{
            position:absolute;
            right:0;
        }
    }
    /deep/ .el-dialog{
        border-radius: 10px;
    }
    /deep/.el-dialog__header {
        padding: 0
    }
    /deep/.el-dialog__body {
        text-align: initial;
        padding: 30px 25px 30px;
        border-radius: 10px;
        margin-top: -15px;
    }
    /deep/ .el-dialog__headerbtn{
        top:10px;
        font-size: 24px;
    }
    /deep/.el-dialog__close{
        color:#fff !important;
    }
}

.content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    color: var(--RED-F21137);
    font-size: 16px;
    white-space: pre-line;
    word-break: break-word;
}

.NB_dialog{
    /deep/.el-dialog__body{
        background:linear-gradient(var(--RED-C11C20), 3%, white, white, white, white) !important;
    }
    /deep/ .header-title{
        background-image: linear-gradient(var(--RED-C11C20), var(--RED-79031D), var(--RED-68020F)) !important;
    }
}

.SH_dialog{
    /deep/.el-dialog__body{
        background:linear-gradient(var(--BLUE-006699), 3%, white, white, white, white) !important;
    }
    /deep/ .header-title{
        background-image: linear-gradient(var(--BLUE-3366FF), var(--BLUE-5493f4), var(--BLUE-006699)) !important;
    }
}

.QD_dialog{
    /deep/.el-dialog__body{
        background:linear-gradient(var(--GREEN-003300), 3%, white, white, white, white) !important;
    }
    /deep/ .header-title{
        background-image: linear-gradient(var(--GREEN-006600), var(--GREEN-336600), var(--GREEN-003300)) !important;
    }
}

.TJ_dialog{
    /deep/.el-dialog__body{
        background:linear-gradient(var(--YELLOW-FF9900), 3%, white, white, white, white) !important;
    }
    /deep/ .header-title{
        background-image: linear-gradient(var(--YELLOW-FF9900), var(--YELLOW-CC9966), var(--YELLOW-CC9933)) !important;
    }
}

.XM_dialog{
    /deep/.el-dialog__body{
        background:linear-gradient(var(--PURPLE-330099), 3%, white, white, white, white) !important;
    }
    /deep/ .header-title{
        background-image: linear-gradient(var(--PURPLE-330099), var(--PURPLE-330066), var(--PURPLE-000066)) !important;
    }
}
</style>
